import React, { useEffect, useState } from 'react';
import { LocationOn, Star } from '@mui/icons-material'
import founderimg from '../../assets/img/founder.webp';
import { useDispatch, useSelector } from 'react-redux';
import { clearData } from '../../store/apiSlice/OngoingNannySlice';
import { NannyPastUserList, clearData as clearPastData } from '../../store/apiSlice/NannypastSlice';
const STATUS_LABELS = {
  0: "Pending",
  1: "Accepted",
  2: "On The Way",
  3: "Reached",
  4: "Completed",
  5: "Cancelled",
  6: "Rejected",
};


const PastNanny = () => {

  const ongoingData = useSelector((state) => state.rootReducer.NannyPastReducer.data)
  const [dataList, setDataList] = useState(null)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(NannyPastUserList(2))
    return () => {
      dispatch(clearData())
      dispatch(clearPastData())
    }
  }, [])

  useEffect(() => {
    if (ongoingData != null && ongoingData.status === 1) {
      setDataList(ongoingData.data.data)
    }
  }, [ongoingData])


  return (
    <>
      <div className="row all_order_box">
        {dataList != null &&
          dataList.length > 0 ? (
          dataList.map((item) =>
            <div className='col-md-6'>
              <div className='card nany_orders my-2'>
                <div className='card.body d-flex'>
                  <div className='card.img mr-2'>
                    <img alt='user' src={item.userId.profileImage} className="rounded-circle" />
                  </div>
                  <div>
                    <div className='card-title'>
                      <h6>{item.userId.firstName} {item.userId.lastName}</h6>
                      <p className="text-sm-end text-md-start text-lg-end">${item.price}</p>
                    </div>

                    <div className='Card.Text'>
                      <div className="nanny-info">
                        <div className="location mb-1 d-flex align-items-center"><LocationOn /><span>{item.address}</span></div>
                        <p className="time mb-0 text-truncate">{item.date} <span>{item.time}</span></p>
                        {Number(item.ratingStar) > 0 && (
                          <p>
                            <span className="star">
                              <Star /> {Number(item.ratingStar).toFixed(1)}
                            </span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='ordered_persons'>
                  <div className="nanny-small-info mt-2">
                    <div className="d-flex justify-content-between align-items-center">

                      <div className="d-flex align-items-center">
                        <img
                          src={founderimg}
                          alt="nanny"
                          className="rounded-circle me-2"
                          width={40}
                          height={40}
                        />
                        <h4 className="mb-0">{item.categoryId?.name}</h4>
                      </div>

                      {/* RIGHT: STATUS */}
                      <span
                        className={`status-badge status-${item.status ?? 0}`}
                      >
                        {STATUS_LABELS[item.status] || "Pending"}
                      </span>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <p style={{ fontWeight: 600 }}>No Bookings Found</p>
        )
        }
      </div>
    </>
  )
}

export default PastNanny
